<template>
    <!--FAQ Page Start-->
    <section class="faq-page" style="padding: 40px 0 30px !important;">
            <div class="container">
                <div class="section-title text-center">
                    <!-- <span class="section-title__tagline">IEH Electricidad</span> -->
                    <!-- <h2 class="section-title__title">Nuestra empresa está <br> dividida en dos</h2> -->

                    <div class="row">
                        <div class="col-2"></div>
                        <div class="col-8">
                            <h4 class="text-center" style="color: #010101;">En IEH Electricidad realizamos todo tipo de mantenciones tanto eléctricas como hidráulicas, tales como:</h4>
                        </div>
                    </div>
                    
                </div>
                <div class="row">
                      <!-- Acordion#1 Inicio -->
                    <div class="col-xl-6 col-lg-6">
                        <div class="faq-page__single">
                            <div class="accrodion-grp faq-one-accrodion" data-grp-name="faq-one-accrodion-1">

                                <div class="accrodion accrodion-new" id="accrodion-1">
                                    <div class="accrodion-title">
                                        <h4>Diseño e instalación de tableros de fuerza y control.</h4>

                                        <div desplegable=true @click="desplegar(1)">
                                            <i class="fas"></i>
                                        </div>
                                    </div>
                                    <div class="accrodion-content" desplegable=true>
                                        <div class="inner">
                                            <p>Partidas convencionales Y/D, variadores de frecuencia, partidores suaves</p>
                                        </div><!-- /.inner -->
                                    </div>
                                </div>

                                <div class="accrodion accrodion-new" id="accrodion-2">
                                    <div class="accrodion-title">
                                        <h4>Extracción e instalación de bombas de pozo profundo.</h4>

                                        <div desplegable=false @click="desplegar(2)">
                                            <i class="fas"></i>
                                        </div>
                                    </div>
                                    <div class="accrodion-content" desplegable=false>
                                        <div class="inner">
                                            <!-- <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
                                                tempor incididunt ut labore et dolore magna aliqua.</p> -->
                                        </div><!-- /.inner -->
                                    </div>
                                </div>

                                <div class="accrodion accrodion-new" id="accrodion-3">
                                    <div class="accrodion-title">
                                        <h4>Pruebas de bombeo.</h4>
                                        
                                        <div desplegable=false @click="desplegar(3)">
                                            <i class="fas"></i>
                                        </div>
                                    </div>
                                    <div class="accrodion-content" desplegable=false>
                                        <div class="inner">
                                            <!-- <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
                                                tempor incididunt ut labore et dolore magna aliqua.</p> -->
                                        </div><!-- /.inner -->
                                    </div>
                                </div>

                                <div class="accrodion accrodion-new" id="accrodion-4">
                                    <div class="accrodion-title">
                                        <h4>Sistemas de Impulsión de agua.</h4>

                                        <div desplegable=false @click="desplegar(4)">
                                            <i class="fas"></i>
                                        </div>
                                    </div>
                                    <div class="accrodion-content" desplegable=false>
                                        <div class="inner">
                                            <!-- <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
                                                tempor incididunt ut labore et dolore magna aliqua.</p> -->
                                        </div><!-- /.inner -->
                                    </div>
                                </div>

                                <div class="accrodion accrodion-new" id="accrodion-5">
                                    <div class="accrodion-title">
                                        <h4>Mantenimiento de motores eléctricos e hidráulicos.</h4>

                                        <div desplegable=false @click="desplegar(5)">
                                            <i class="fas"></i>
                                        </div>
                                    </div>
                                    <div class="accrodion-content" desplegable=false>
                                        <div class="inner">
                                            <!-- <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
                                                tempor incididunt ut labore et dolore magna aliqua.</p> -->
                                        </div><!-- /.inner -->
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>  
                    <!-- Acordion#1 Fin -->
                    
                    <!-- Acordion#2 Inicio -->
                    <div class="col-xl-6 col-lg-6">
                        <div class="faq-page__single">
                            <div class="accrodion-grp faq-one-accrodion" data-grp-name="faq-one-accrodion-2">
                                <div class="accrodion accrodion-new" id="accrodion-6">
                                    <div class="accrodion-title">
                                        <h4>Sistema de generación Fotovoltaica.</h4>

                                        <div desplegable=false @click="desplegar(6)">
                                            <i class="fas"></i>
                                        </div>
                                    </div>
                                    <div class="accrodion-content" desplegable=false>
                                        <div class="inner">
                                            <p>Off grid para Bombeo de agua y soluciones habitacionales</p>
                                        </div><!-- /.inner -->
                                    </div>
                                </div>
                                <div class="accrodion accrodion-new" id="accrodion-7">
                                    <div class="accrodion-title">
                                        <h4>Sistemas de riego tecnificado.</h4>

                                        <div desplegable=false @click="desplegar(7)">
                                            <i class="fas"></i>
                                        </div>
                                    </div>
                                    <div class="accrodion-content" desplegable=false>
                                        <div class="inner">
                                            <!-- <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
                                                tempor incididunt ut labore et dolore magna aliqua.</p> -->
                                        </div><!-- /.inner -->
                                    </div>
                                </div>
                                <div class="accrodion accrodion-new" id="accrodion-8">
                                    <div class="accrodion-title">
                                        <h4>Reparaciones y mantenimientos eléctricos industriales.</h4>

                                        <div desplegable=false @click="desplegar(8)">
                                            <i class="fas"></i>
                                        </div>
                                    </div>
                                    <div class="accrodion-content" desplegable=false>
                                        <div class="inner">
                                            <!-- <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
                                                tempor incididunt ut labore et dolore magna aliqua.</p> -->
                                        </div><!-- /.inner -->
                                    </div>
                                </div>
                                <div class="accrodion last-chiled accrodion-new" id="accrodion-9">
                                    <div class="accrodion-title">
                                        <h4>Instalaciones de baja y media tensión</h4>

                                        <div desplegable=false @click="desplegar(9)">
                                            <i class="fas"></i>
                                        </div>
                                    </div>
                                    <div class="accrodion-content" desplegable=false>
                                        <div class="inner">
                                            <!-- <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
                                                tempor incididunt ut labore et dolore magna aliqua.</p> -->
                                        </div><!-- /.inner -->
                                    </div>
                                </div>
                                <div class="accrodion last-chiled accrodion-new" id="accrodion-10">
                                    <div class="accrodion-title">
                                        <h4>Certificados y planos eléctricos TE1, TE2 y TE3.</h4>

                                        <div desplegable=false @click="desplegar(10)">
                                            <i class="fas"></i>
                                        </div>
                                    </div>
                                    <div class="accrodion-content" desplegable=false>
                                        <div class="inner">
                                            <!-- <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
                                                tempor incididunt ut labore et dolore magna aliqua.</p> -->
                                        </div><!-- /.inner -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Acordion#2 Fin -->
                </div>
            </div>
        </section>
        <!--FAQ Page End-->
  
  
</template>

<style>
    /* .accrodion .accrodion-content{
        display: none;
    }
    .accrodion.active .accrodion-content{
        display: block;
    } */

    .accrodion-new .accrodion-title h4::before, .accrodion-new .accrodion-title h4::after{
        display: none;
    }
    .accrodion-new .accrodion-title div{
        height: 50px;
        width: 50px;
        border-radius: 100%;
        position: absolute;
        top: 5px;
        right: 10px;
    }
    .accrodion-new .accrodion-title [desplegable="true"]{
        background-color: var(--oxpins-primary);
        text-align: center;
        line-height: 50px;
    }
    .accrodion-new .accrodion-title [desplegable="false"]{
        background-color: var(--oxpins-extra);
        text-align: center;
        line-height: 45px;
    }
    .accrodion-new .accrodion-title [desplegable="true"] i:before{
        content: "\f056";
    }
    .accrodion-new .accrodion-title [desplegable="false"] i:before{
        content: "\f067";
        color: var(--oxpins-extra);
        background-color: var(--oxpins-black);
        border-radius: 100%;
        font-size: 8px;
        height: 15px;
        width: 15px;
        padding: 4px;
        line-height: 15px;
    }

    .accrodion-content{
        overflow: hidden;
        max-height: 0px;
        padding: 0px 40px 0px;
        transition: max-heiht 1s, padding .5s ease-in;
    }
    .accrodion-content[desplegable="true"]{
        overflow: hidden;
        padding: 0px 40px 21px;
        max-height: 500px;
        transition: max-height 1.5s, padding .5s ease-out;
    }
    .accrodion-content[desplegable="false"]{
        overflow: hidden;
        padding: 0px 40px 0px;
        max-height: 0;
        transition: max-height 0.5s, padding .5s ease-out;
    }

    @media only screen and (max-width: 414px){
         .accrodion-new .accrodion-title [desplegable="true"] {
                background-color: var(--oxpins-primary);
                text-align: center;
                line-height: 40px;
            }
            .accrodion-new .accrodion-title div {
                height: 40px;
                width: 40px;
                border-radius: 100%;
                position: absolute;
                top: 7px;
                right: 10px;
            } 

            .accrodion-new .accrodion-title [desplegable="false"] i:before {
                content: "\f067";
                color: var(--oxpins-extra);
                background-color: var(--oxpins-black);
                border-radius: 100%;
                font-size: 11px;
                height: 15px;
                width: 18px;
                padding: 4px;
                line-height: 14px;
            }
        }

        @media only screen and (max-width: 375px){
         .accrodion-new .accrodion-title [desplegable="true"] {
                background-color: var(--oxpins-primary);
                text-align: center;
                line-height: 36px;
            }
            .accrodion-new .accrodion-title div {
                height: 36px;
                width: 36px;
                border-radius: 100%;
                position: absolute;
                top: 7px;
                right: 2px;
            } 

            .accrodion-new .accrodion-title [desplegable="false"] i:before {
                content: "\f067";
                color: var(--oxpins-extra);
                background-color: var(--oxpins-black);
                border-radius: 100%;
                font-size: 11px;
                height: 15px;
                width: 18px;
                padding: 4px;
                line-height: 14px;
            }
        }

</style>

<script>

    export default {
        methods: {
            desplegar(id){
                $('.accrodion-title div').attr('desplegable', false)
                //$('.accrodion-title div').removeClass('active')
                $('.accrodion-content').attr('desplegable', false)
                //$('#accrodion-' + id).addClass('active');
                $('#accrodion-' + id + ' .accrodion-title div').attr('desplegable', true);
                $('#accrodion-' + id + ' .accrodion-content').attr('desplegable', true);
            },
        }
    }

</script>